// @flow
import * as React from 'react'

import './FormGroup.scss'

type Props = {
  children: React.Node,
}

export default class FormGroup extends React.Component<Props> {
  render = () => {
    return <div className="FormGroup">{this.props.children}</div>
  }
}
